<template>
  <v-container class="pa-0" v-if="info.alertGlobalLevel || info.alertRouteLevel">
    <!-- Alerts -->
    <v-row v-if="info.alertGlobalLevel" style="max-width: 1250px" class="mx-auto animated fadeIn delay-1">
      
      <v-container fill-height fluid>
        <v-card
          tile
          class="bg-orange-lighten-4"
          style="min-height: 65px; width: 100%"
        >      
          <v-card-text class="d-flex align-center text-orange-darken-3 body-1">
            <span class="text-h4 text-orange-darken-3 mdi mdi-bell mr-5"></span>
            <span class="text-h7">{{ info.alertGlobalLevel }}</span>
          </v-card-text>
        </v-card>
      </v-container>
    </v-row>
    <v-row v-if="info.alertRouteLevel" style="max-width: 1250px" class="mx-auto animated fadeIn delay-1">
      <v-container fill-height fluid>
        <v-card
          tile
          class="bg-orange-lighten-4"
          style="min-height: 65px; width: 100%"
        >
          <v-card-text class="d-flex align-center text-orange-darken-3 body-1">
            <span class="text-h4 text-orange-darken-3 mdi mdi-bell mr-5"></span>
            <span class="text-h7">{{ info.alertRouteLevel }}</span>
          </v-card-text>
        </v-card>
      </v-container>
    </v-row>    
  </v-container>
</template>

<script>
export default {
  name: "NotificationsAlert",
  props: ["info"],
};
</script>

<style scoped>
</style>

